const massText = {
    path: 'massText',
    component: resolve => require(['@/pages/admin/message/massText/index.vue'], resolve)
}

export default massText